import { render } from "./settingheadertab.vue?vue&type=template&id=4d26b42e&scoped=true"
import script from "./settingheadertab.vue?vue&type=script&lang=js"
export * from "./settingheadertab.vue?vue&type=script&lang=js"

import "./settingheadertab.vue?vue&type=style&index=0&id=4d26b42e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d26b42e"]])

export default __exports__